<template>
  <v-row class="mr-2 ml-2 mt-2">
    <v-row >
      <v-col>
        <h2><b>Quem Registrou: </b></h2><p>{{ item.colaborador.apelido }} - {{item.colaborador.especialidade.nome}}</p>
      </v-col>
      <v-col>
        <h2><b>Responsável: </b></h2><p>{{ item.responsavel.apelido }} - {{item.responsavel.especialidade.nome}}</p>
      </v-col>
      <v-col>
        <h2><b>Data da Ocorrência: </b></h2><p>{{ item.dataOcorrencia | formatDatabr }}</p>
      </v-col>
   
    </v-row>
    <v-row>
      <v-col>
        <h2><b>Ocorrência: </b></h2><p></p>
          <p> {{ item.ocorrencia }} </p> 
      </v-col>
      <v-col>
        <h2><b>Meta: </b></h2><p></p>
          <p> {{ item.meta }} </p> 
      </v-col>
      <v-col>
        <h2><b>Conduta: </b></h2><p></p>
          <p> {{ item.desfecho_final }} </p> 
      </v-col>

    </v-row>
  </v-row>
</template>

<script>

export default {
  name: "AcionamentoExpand",
  props: {
    item: Object,
  },
}
</script>

